import React, { FormEvent, useState, useContext, useEffect } from "react";
import AuthContext from "../../../contexts/AuthContext";
import { RouteProps } from "react-router-dom";

import Input from "../../../components/Form/Input";
import Button from "../../../components/Form/Button";

import { SimpleResponse } from "../../../services/api/Request";
import Sales, { ISales, IChannel } from "../../../services/api/Sales";
import { SetModal } from "../../../components/Modal";
import WeekPeriod from "../../../services/api/WeekPeriod";

interface FormProps extends RouteProps {
  sale: ISales;
  month: number;
  year: number;
}

interface months {
   [key: number] : string
}

const Form: React.FC<FormProps> = ({ sale, month, year }) => {
  const { user } = useContext(AuthContext);
  const readOnly = user!.profile.name === "Viewer";
  const [response, setResponse] = useState<SimpleResponse>();
  const isUpdate = sale && sale.id;
  const [weekPeriod, setWeekPeriod] = useState<boolean>(false);
  const monthNames: months = {
    1: "January",
    2: "February",
    3: "March",
    4: "April",
    5: "May",
    6: "June",
    7: "July",
    8: "August",
    9: "September",
    10: "October",
    11: "November",
    12: "December"
  };
  const previousMonth: number = month === 1 ? 12 : month - 1;

  useEffect(() => {
    Promise.all([WeekPeriod.GetSales()])
      .then((value) => {
        const day = new Date().getDate();
        setWeekPeriod(day >= value[0].startDateW1 && day <= value[0].endDateW1);
      })
      .catch(console.log);
  }, []);


  async function handleFormSubmit(event: FormEvent) {
    event.preventDefault();
    const formData: FormData = new FormData(event.target as HTMLFormElement);
    let data: any = {
      groupId: sale.groupId,
      channels: []
    };

    formData.forEach((value: FormDataEntryValue, key: string) => {
        if (key.indexOf("channel") === -1) data[key] = value ? value : 0;
    });

    sale.channels.forEach((value: IChannel, key: number) => {
      
      const elName: string = "channel" + value.channelId;
      const Previous: string | null = normalizeNumber(formData.get(elName + "[previousTradeSalesActual]"));
      const BP: string | null = normalizeNumber(formData.get(elName + "[tradeSalesBusinessPlan]"));
      const FRE: string | null = normalizeNumber(formData.get(elName + "[tradeSalesFRE]"));
      const SRE: string | null = normalizeNumber(formData.get(elName + "[tradeSalesSRE]"));
      const LE: string | null = normalizeNumber(formData.get(elName + "[tradeSalesLE]"));
      const OP: string | null = normalizeNumber(formData.get(elName + "[tradeSalesOP]"));

      data["channels"].push({
        channelId: value.channelId,
        id: value.id,
        previousTradeSalesActual:  Previous ? Previous: 0,
        tradeSalesBusinessPlan: BP ? BP : 0,
        tradeSalesFRE: FRE ? FRE : 0,
        tradeSalesSRE: SRE ? SRE : 0,
        tradeSalesLE: LE ? LE : 0,
        tradeSalesOP: OP ? OP : 0,
        previousDate: value.previousDate,
        currentDate: value.currentDate
      });
    });
    
    const response: SimpleResponse = await (isUpdate
      ? Sales.Update(sale.id, data)
      : Sales.Create(year, month, data));
    
    setResponse(response);
  }

  function normalizeNumber(value:FormDataEntryValue | null){
    return value === null ? null : (value+"").replace(/\./g,'');
  }

  function list(obj: any): any {
    return (
      <div className="form form--border" key={obj.channelName}>
        <h3 className="form__title">{obj.channelName}</h3>
        <div className="form__fields--sideBySide">
          <Input
            masked={true}
            disabled={readOnly || !weekPeriod}
            name={"channel" + obj.channelId + "[previousTradeSalesActual]"}
            title={`Closing (${monthNames[previousMonth]})`}
            value={obj.previousTradeSalesActual}
            type="number"
          />

          <Input
            masked={true}
            disabled={readOnly || !weekPeriod}
            name={"channel" + obj.channelId + "[tradeSalesBusinessPlan]"}
            title="Business Plan"
            value={obj.tradeSalesBusinessPlan}
            type="number"
          />
          <Input
            masked={true}
            disabled={readOnly || !weekPeriod}
            name={"channel" + obj.channelId + "[tradeSalesFRE]"}
            title="FRE"
            value={obj.tradeSalesFRE}
            type="number"
          />
          <Input
            masked={true}
            disabled={readOnly || !weekPeriod}
            name={"channel" + obj.channelId + "[tradeSalesSRE]"}
            title="SRE"
            value={obj.tradeSalesSRE}
            type="number"
          />
          <Input
            masked={true}
            disabled={readOnly || !weekPeriod}
            name={"channel" + obj.channelId + "[tradeSalesLE]"}
            title="LE"
            value={obj.tradeSalesLE}
            type="number"
          />
          <Input
            masked={true}
            disabled={readOnly || !weekPeriod}
            name={"channel" + obj.channelId + "[tradeSalesOP]"}
            title="OP"
            value={obj.tradeSalesOP}
            type="number"
          />
        </div>
      </div>
    );
  }

  return (
    <React.Fragment>
          {response ? SetModal.FromResponse(response, () => {
              setResponse(undefined);
              if (response.status === 200) {
                  //history.push({ pathname: "/empty" });
                  //history.goBack();
              }
          }) : null}
      <form
        className="container details__forms form__group-container"
        onSubmit={handleFormSubmit}
      >
        {sale.channels.map(list)}
        
        <div></div>
        <Button
          disabled={readOnly}
          className="button button--big button--blue details__button--form"
          title={isUpdate ? "Save" : "Send"}
        />
      </form>
    </React.Fragment>
  );
};

export default Form;
